import React from 'react'
import { Flex, Heading, Card, Text, Box, Button } from "rebass/styled-components";
import { GET_TALKING_POINTS } from '../../graphql/queries';
import { useQuery } from '@apollo/client';
import { IGetPatientTalkingPointsInput, IGetPatientTalkingPointsOutput, IPatientTalkingPointsProblems } from '../../graphql/types/queries/patientCases';
import PleaseWait from '../../components/PleaseWait';
import moment from 'moment';

export type TLabResultsResultedFlag = 'IN REF.' | 'IN OPTIMAL' | 'ABN. LOW' | 'ABN. HIGH' | ''
export type TLabResultsResultedMarker = 'TPO' | 'TSH' | 'fT3' | 'fT4' | 'rT3' | 'VitaminD'
const _getPonderation = (flag: TLabResultsResultedFlag) => {
  if (flag === 'ABN. LOW') return -1;
  if (flag === 'IN OPTIMAL') return 0;
  if (flag === 'IN REF.') return 1;
  if (flag === 'ABN. HIGH') return 2;
  return 10;
};

const _getColorCSS = (flag: TLabResultsResultedFlag) => {
  if (flag === 'ABN. LOW') return red;
  if (flag === 'IN OPTIMAL') return green;
  if (flag === 'IN REF.') return orange;
  if (flag === 'ABN. HIGH') return red;
};

const flexHorizontal = ` display: flex;flex-direction: row;font-weight: 500 !important;font-size: 12px !important;line-height: 12px;`;
const red = { color: 'red' };
const green = { color: 'green' };
const orange = { color: 'orange' };
const grey = { color: `darkgrey`, fontSize: `11px !important` };
const markerStyle = { paddingRight: '24px !important' };
const newStyle = { fontWeight: '500 !important' };
const previousStyle = { fontWeight: '300 !important' };
const strikeStyle = { textDecoration: 'line-through' };
const verticalDivider = { width: `24px !important;` };
const valuesStyle = { fontSize: `14px !important` };
const unchanged = `opacity: 0.5;`;
const ptId = `font-weight: 700;  font-size: 20px !important;margin-bottom: 16px !important;margin-top: 24px !important;`;
const wrapper = `margin-left: 24px !important;  padding: 12px;`;


export interface ITalkingPointsProps {
  athenaId: string
  patientName: string
}

const getOrderedSymptoms = (symptoms: Array<IPatientTalkingPointsProblems>) => {
  const severities: Array<{
    severity: string,
    symptoms: Array<string>
  }> = []
  for (let index = 0; index < symptoms.length; index++) {
    const element = symptoms[index];
    if (element.events && element.events.eventtype === 'HIDDEN') continue
    if (!element.events || !element.events.note) continue
    const sev = severities.findIndex(x => x.severity === ((element.events || {}).note || '').replace(/\"/g, ''))
    if ((element.name || '') === 'Chart opening') {
      severities.push({
        severity: '',
        symptoms: [((element.events || {}).note || '').replace('Other medical concerns / details -', '').replace(/\"/g, '')]
      })
    } else {
      if (((element.events || {}).note || '').indexOf('Other medical concerns / details -') > -1) {

        severities.push({
          severity: '',
          symptoms: [((element.events || {}).note || '').replace('Other medical concerns / details - ', '').replace(/\"/g, '')]
        })
      } else {
        if (sev < 0) {
          severities.push({
            severity: ((element.events || {}).note || '').replace(/\"/g, ''),
            symptoms: [(element.name || '').replace(/\"/g, '') || '']
          })
        } else {
          severities[sev].symptoms.push((element.name || '').replace(/\"/g, ''))
        }
      }
    }
  }

  return severities
}

const getOrderedHistoricalSymptoms = (symptoms: Array<IPatientTalkingPointsProblems>) => {
  const severities: Array<{
    severity: string,
    symptoms: Array<string>
  }> = []
  for (let index = 0; index < symptoms.length; index++) {
    const element = symptoms[index];
    if (element.events && element.events.eventtype !== 'HIDDEN') continue
    // if (!element.events || !element.events.note) continue
    const sev = severities.findIndex(x => x.severity === ((element.events || {}).note || '').replace(/\"/g, ''))
    if ((element.name || '') === 'Chart opening') {
      severities.push({
        severity: '',
        symptoms: [((element.events || {}).note || '').replace('Other medical concerns / details -', '').replace(/\"/g, '')]
      })
    } else {
      if (((element.events || {}).note || '').indexOf('Other medical concerns / details -') > -1) {

        severities.push({
          severity: '',
          symptoms: [((element.events || {}).note || '').replace('Other medical concerns / details - ', '').replace(/\"/g, '')]
        })
      } else {
        if (sev < 0) {
          severities.push({
            severity: ((element.events || {}).note || '').replace(/\"/g, ''),
            symptoms: [(element.name || '').replace(/\"/g, '') || '']
          })
        } else {
          severities[sev].symptoms.push((element.name || '').replace(/\"/g, ''))
        }
      }
    }
  }
  console.log('getOrderedHistoricalSymptoms', { symptoms, severities })
  return severities
}

export const TalkingPoints: React.FC<ITalkingPointsProps> = ({ athenaId, patientName }) => {
  const { data, loading, error } = useQuery<IGetPatientTalkingPointsOutput, IGetPatientTalkingPointsInput>(GET_TALKING_POINTS, {
    variables: {
      patientId: athenaId
    }
  })
  if (!!loading) {
    return (
      <Flex flexDirection={'column'} flex={1}>
        <Heading mb={4} mt={3} textAlign={'center'}>Potential Talking Points with {patientName}</Heading>
        <PleaseWait text={' '} />
      </Flex>)
  }

  if(!!error){
    return (
      <Flex flexDirection={'column'} flex={1}>
        <Heading mb={4} mt={3} textAlign={'center'}>Potential Talking Points with {patientName}</Heading>
        <Text textAlign={'center'}>An error occured</Text>
      </Flex>)
  }
  if(!data?.providerGetTalkingPoints?.isMobileUser &&
    (!data?.providerGetTalkingPoints?.bmi || data?.providerGetTalkingPoints?.bmi.length<1) &&
    !data?.providerGetTalkingPoints?.overallWellBeing &&
    !data?.providerGetTalkingPoints?.palomaExpectations &&
    !data?.providerGetTalkingPoints?.thyroidMedAdjustment &&
    (!data?.providerGetTalkingPoints?.flags || data?.providerGetTalkingPoints?.flags.length<1) &&
    (!data?.providerGetTalkingPoints?.problems || data?.providerGetTalkingPoints?.problems.length<1)
    ){
      return (
        <Flex flexDirection={'column'} flex={1}>
          <Heading mb={4} mt={3} textAlign={'center'}>Potential Talking Points with {patientName}</Heading>
          <Text textAlign={'center'}>Sorry we could not find any good talking points for this patient</Text>
        </Flex>)
    }
  console.log({ data })
  return (
    <Flex flexDirection={'column'} flex={1}>
      <Heading mb={4} mt={3} textAlign={'center'}>Potential Talking Points with {patientName}</Heading>
      {!!loading ?
        <PleaseWait text={' '} /> : (
          <Flex flexDirection={'column'}>
            {!data?.providerGetTalkingPoints?.isMobileUser && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Text>Invite patient to use Paloma Health Mobile App</Text>
                </Flex>
              </Flex>
            )}
            {data?.providerGetTalkingPoints?.bmi && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Text>BMI Evolution:</Text>
                  {data.providerGetTalkingPoints.bmi.map((xx, i) => {
                    return (
                      <Flex ml={3}>
                        <Text fontWeight={i === 0 ? 500 : 300} fontSize={i === 0 ? '14px' : '12px'}>{!!xx.timestamp ? moment(xx.timestamp).format('MM/DD/YYYY') : 'no date'} - </Text>
                        <Text fontWeight={i === 0 ? 500 : 300} fontSize={i === 0 ? '14px' : '12px'}>{Math.round((xx.bmi || '0') as any * 100) / 100}</Text>
                      </Flex>
                    )
                  })}
                </Flex>
              </Flex>
              // <Text mt={2}>Last BMI: <br /><span><strong>&emsp;{Math.round((data?.providerGetTalkingPoints?.bmi||'0')as any * 100) / 100}</strong></span></Text>
            )}
            {data?.providerGetTalkingPoints?.overallWellBeing && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Text mt={2}>How described overall well-being: <br /><span><strong style={{ fontSize: '14px' }}>&emsp;{data?.providerGetTalkingPoints?.overallWellBeing}</strong></span></Text>

                </Flex>
              </Flex>)}
            {data?.providerGetTalkingPoints?.palomaExpectations && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Text mt={2}>Patient's expectations from Paloma Health? <br /><span><strong style={{ fontSize: '14px' }}>&emsp;{data?.providerGetTalkingPoints?.palomaExpectations}</strong></span></Text>

                </Flex>
              </Flex>)}
            {data?.providerGetTalkingPoints?.thyroidMedAdjustment && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Text mt={2}>How many times did adjust thyroid medication (either dose or brand) within the past 12 months?: <br /><span><strong style={{ fontSize: '14px' }}>&emsp;{data?.providerGetTalkingPoints?.thyroidMedAdjustment}</strong></span></Text>

                </Flex>
              </Flex>)}
            {data?.providerGetTalkingPoints?.flags && data?.providerGetTalkingPoints?.flags.length > 0 && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Flex flexDirection={'column'} mt={3}>
                    <Text >Last Lab impacted markers flags:</Text>
                    {data?.providerGetTalkingPoints?.flags.map(x => {
                      return (
                        <div key={x.marker} style={{ display: 'flex', flexDirection: 'row', fontWeight: '500 !important', fontSize: '14px', lineHeight: '12px', marginLeft: '12px' }}>
                          <p style={{ ...red, fontSize: '14px !important' }}>&rarr;</p>
                          <p style={{ fontSize: '14px', ...markerStyle, ...newStyle, marginRight: '12px' }}>{x.marker}:</p>
                          <p style={{ ..._getColorCSS(x.previousFlag as TLabResultsResultedFlag), ...previousStyle, ...strikeStyle, fontSize: '14px' }}>{x.previousFlag}</p>
                          <p>&nbsp;{'->'}&nbsp;</p>
                          <p style={{ ..._getColorCSS(x.currentFlag as TLabResultsResultedFlag), ...newStyle, fontSize: '14px' }}>{x.currentFlag}</p>
                          <div style={{ ...verticalDivider }}>&nbsp;</div>

                          <p style={{ ...grey, ...valuesStyle, fontSize: '14px' }}>({x.previousValue} {x.previousUnit}&nbsp;{'->'}&nbsp;{x.currentValue} {x.currentUnit})</p>
                        </div>)
                    }
                    )}
                  </Flex>
                </Flex>
              </Flex>
            )}

            {data?.providerGetTalkingPoints?.problems && data?.providerGetTalkingPoints?.problems.length > 0 && (
              <Flex flexDirection={'row'} mt={2} alignItems={'baseline'}>
                <input type='checkbox' />
                <Flex flexDirection={'column'} ml={2}>
                  <Flex flexDirection={'column'} mt={3}>
                    <Text fontWeight={500}>Symptoms:</Text>
                    {getOrderedSymptoms(data?.providerGetTalkingPoints?.problems).map(x => {
                      return (
                        <Flex key={x.severity} ml='12px'>
                          <Text style={{ fontStyle: 'italic' }}>{x.severity || 'Other'}:&nbsp;</Text>
                          <Text flex={1}>{x.symptoms.join(', ')}</Text>
                        </Flex>)
                    }
                    )}
                    {getOrderedHistoricalSymptoms(data?.providerGetTalkingPoints?.problems).map(x => {
                      return (
                        <Flex key={x.severity} ml='12px'>
                          <Text style={{ fontStyle: 'italic', fontWeight: 300 }}>(historical)&nbsp;</Text>
                          <Text style={{ fontStyle: 'italic', fontWeight: 300, textDecoration: 'line-through' }}>{x.severity || 'Other'}:&nbsp;</Text>
                          <Text flex={1} style={{ fontWeight: 300, textDecoration: 'line-through' }}>{x.symptoms.join(', ')}</Text>
                        </Flex>)
                    }
                    )}
                  </Flex>
                </Flex>
              </Flex>
            )}
          </Flex>
        )}

    </Flex>
  );
}